import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import thunk from "redux-thunk";
import App from "./App";
import "./index.scss";
import rootReducer from "./redux/reducers";
import * as serviceWorker from "./serviceWorker";

export const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  // strict mode disabled because BlueprintUI has some deprecated methods
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
